import PropTypes from 'prop-types';
import React, { useState, forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import TextArea from 'app/components/shared/TextArea';
import { TransactionalSolidButton, SecondaryTextButton } from '@bibliocommons/base-buttons';
import Panel from 'app/components/shared/Panel';
import './TextUgcEditor.scss';

const TextUgcEditor = forwardRef((props, ref) => {
  const {
    children,
    label,
    isLoading,
    initialContent,
    metadataId,
    ugcType,
    maxLength,
    handleConfirm,
    handleCancel,
    displayMessage
  } = props;

  const [text, setText] = useState(initialContent || '');

  return (
    <div className="cp-ugc-editor" ref={ref}>
      <Panel>
        <TextArea
          value={text}
          handleChange={setText}
          id={`${metadataId}-ugc-editor-text-area`}
          maxLength={maxLength}
          label={label}
          displayMessage={displayMessage}
          fitToText
          minHeight="9rem"
        />
        {children}
        <div className="ugc-editor__buttons">
          <SecondaryTextButton dataKey="cancel-button" handleClick={handleCancel}>
            <FormattedMessage id="button_cancel" />
          </SecondaryTextButton>
          <TransactionalSolidButton
            handleClick={() => handleConfirm(text)}
            disabled={!text}
            aria-disabled={!text}
            isLoading={isLoading}
            dataKey="post-ugc"
          >
            <FormattedMessage id={`post_${ugcType}`} />
          </TransactionalSolidButton>
        </div>
      </Panel>
    </div>
  );
});

TextUgcEditor.defaultProps = {
  initialContent: '',
  maxLength: 4000
};

TextUgcEditor.propTypes = {
  metadataId: PropTypes.string.isRequired,
  ugcType: PropTypes.string.isRequired,
  handleConfirm: PropTypes.func,
  handleCancel: PropTypes.func,
  initialContent: PropTypes.string,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  children: childrenShape,
  displayMessage: PropTypes.string
};

export default TextUgcEditor;
